import { useSelector } from "react-redux";

const Pagination = (props) => {
  const search = useSelector((state) => state.search);
  const pages = [];

  if (search.maxPage < 10) {
    for (let i = 0; i < search.maxPage + 1; i++) {
      pages.push(i);
    }
  } else if (props.currentPage < 2 && search.maxPage + 1 > 3) {
    pages.push(0, 1, 2);
  } else if (props.currentPage >= 2 && props.currentPage === search.maxPage) {
    pages.push(props.currentPage - 1, props.currentPage);
  } else if (
    props.currentPage >= 2 &&
    props.currentPage === search.maxPage - 2
  ) {
    pages.push(props.currentPage - 1, props.currentPage, search.maxPage - 1);
  } else if (props.currentPage >= 2 && search.maxPage + 1 > 3) {
    pages.push(props.currentPage - 1, props.currentPage, props.currentPage + 1);
    /* for (let i = 0; i < search.maxPage + 1; i++) {
      pages.push(i)
    } */
  }
  const handleNumber = (n) => {
    // dispatch(setPage(n))
    props.handlePageClick(n);
  };

  return (
    <div className={`flex flex-row ${search.maxPage + 1 < 2 ? "hidden" : ""}`}>
      {search.maxPage >= 10 && props.currentPage >= 2 ? (
        <div
          className="text-2xl px-2 hover:opacity-50 cursor-pointer"
          onClick={() => handleNumber(0)}
        >
          1
        </div>
      ) : null}
      {search.maxPage >= 10 && props.currentPage > 2 ? (
        <div className="text-2xl px-2 hover:opacity-50 cursor-pointer">...</div>
      ) : null}
      {pages.map((p) => (
        <div
          className={`text-2xl px-2 hover:opacity-50 cursor-pointer ${
            p === props.currentPage ? "underline" : ""
          }`}
          key={"page-" + p}
          onClick={() => handleNumber(p)}
        >
          {p + 1}
        </div>
      ))}
      {search.maxPage >= 10 &&
      search.maxPage + 1 > 3 &&
      props.currentPage <= search.maxPage - 3 ? (
        <div className="text-2xl px-2 hover:opacity-50 cursor-pointer">...</div>
      ) : null}
      {search.maxPage >= 10 && props.currentPage <= search.maxPage - 3 ? (
        <div
          className={`text-2xl px-2 hover:opacity-50 cursor-pointer`}
          onClick={() => handleNumber(search.maxPage)}
        >
          {search.maxPage + 1}
        </div>
      ) : null}
    </div>
  );
};
export default Pagination;
